// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"182":"79b748fb","751":"ac5915fb","891":"75666b8d","964":"a76c14b3"}[chunkId] || chunkId) + "." + {"26":"ea5826df3731aef5","182":"c0f1040eae9650a9","751":"2b767449b6e6ae16","891":"9d38fc397667c4e6","956":"4370a032ac2099ba","964":"6d4895c7bd022d47"}[chunkId] + ".js";
};